/**
 * Centralised rule-type configuration.
 * Every place in the frontend that needs enforcement colours, labels, icons,
 * or chip styles should import from here rather than hardcoding values.
 *
 * Extending: add a new key to RULE_TYPES — rendering, serialisation, and
 * validation all pick it up automatically.
 */

export const RULE_TYPES = {
  denied: {
    label:       'Denied',
    autoVerb:    'cannot use',
    color:       '#dc2626',
    icon:        '✕',
    chipBg:      '#fee2e2',
    chipColor:   '#dc2626',
    chipBorder:  '#fca5a5',
    edgeStyle:   'dashed',
    desc:        'Dependency is forbidden. Violations will be flagged in CI.',
    hint:        'Use to enforce hard architectural boundaries.',
  },
  warning: {
    label:       'Warning',
    autoVerb:    'should avoid',
    color:       '#d97706',
    icon:        '⚠',
    chipBg:      '#fef9c3',
    chipColor:   '#92400e',
    chipBorder:  '#fcd34d',
    edgeStyle:   'solid',
    desc:        'Dependency is discouraged. Violations produce warnings.',
    hint:        'Use for legacy or transitional dependencies you want to phase out.',
  },
  info: {
    label:       'Info',
    autoVerb:    'uses',
    color:       '#0ea5e9',
    icon:        'ℹ',
    chipBg:      '#e0f2fe',
    chipColor:   '#0369a1',
    chipBorder:  '#7dd3fc',
    edgeStyle:   'solid',
    desc:        'Informational — dependency is tracked but not enforced.',
    hint:        'Use to document dependencies without imposing governance rules.',
  },
};

/** Returns the canonical edge colour for an enforcement value. */
export function ruleColor(enforcement) {
  return RULE_TYPES[enforcement]?.color ?? '#94a3b8';
}

/** Returns all rule type keys in display order. */
export const RULE_TYPE_KEYS = Object.keys(RULE_TYPES);
